/** Mongo ObjectId — never allowed as a public URL segment. */
export const isMongoId = (value?: string | number | null): boolean =>
  typeof value === "string" && /^[0-9a-fA-F]{24}$/.test(value);

/**
 * Return an encode-ready SEO slug, or empty string when only an id is available.
 * Callers must resolve the slug from the API before navigating.
 */
export const toSeoSlug = (item?: { slug?: string | null; id?: string | number }): string => {
  const slug = item?.slug != null ? String(item.slug).trim() : "";
  if (!slug || isMongoId(slug)) return "";
  return encodeURIComponent(slug);
};
